<template>
  <div>
    <ul class="tabs">
      <li
        v-for="(tabitem, index) in tabItems"
        :key="index"
        class="tab-item"
        :class="{ 'is-active': index === +activeName, 'is-finish': savedActiveName > index, 'is-disabled': showTab < index }"
        @click="tabClick(tabitem, index)"
      >
        {{ tabitem }}
      </li>
    </ul>
    <div v-show="+activeName === 0" class="tab-content">
      <p class="admin-remark">{{ tutorData.remark || '' }}</p>
    </div>
    <div v-show="+activeName === 1" class="tab-content" :disabled="savedActiveName < 1">
      <div :loading="fLoading">
        <el-form ref="form" :rules="rules" :model="userForm" label-width="120px" label-position="left">
          <page-header title="联系信息" style="margin: 40px 0 20px 0" />
          <div class="row">
            <el-form-item label="现居住地址" prop="address">
              <el-input v-model="userForm.address" placeholder="请输入现居住地址" />
            </el-form-item>
            <el-form-item label="手机号" prop="mobile">
              {{ userForm.mobile }} <el-button type="text" @click="changeMobileFunc">修改</el-button>
              <!-- <el-input v-model="userForm.mobile" placeholder="请输入手机号" clearable /> -->
            </el-form-item>
          </div>
          <div class="row">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="userForm.email" placeholder="请输入邮箱" clearable />
            </el-form-item>
          </div>
        </el-form>
        <page-header title="工作信息" style="margin: 40px 0 20px 0">
          <el-button type="text" icon="el-icon-plus" @click="openDialogWork">添加</el-button>
        </page-header>
        <ming-table v-model="WorkInfoTabelData" :fields="column">
          <template #date="{ scope }">
            {{ scope.start_time }}
            &nbsp;至&nbsp;
            {{ scope.end_time }}
          </template>
          <template #options="{ scope }">
            <el-button type="text" @click="delWorkItem(scope)">删除</el-button>
            <el-button type="text" @click="editWorkItem(scope)">修改</el-button>
          </template>
        </ming-table>
      </div>
    </div>
    <div v-show="+activeName === 2" class="tab-content" :disabled="savedActiveName < 2">
      <el-form ref="tutorForm" class="form-wrap" :model="ruleForm">
        <el-form-item prop="teacher_id" :rules="{ required: true, message: '请选择导师', trigger: 'blur' }">
          <el-button size="small" type="primary" :disabled="tutorData?.is_update === 0" @click="openDialog">选择导师</el-button>
        </el-form-item>
        <el-form-item>
          <el-descriptions v-if="checkedItem?.teacher_id > 0" direction="vertical" :column="6" border>
            <el-descriptions-item label="教授姓名">{{ checkedItem?.teacherName || '' }}</el-descriptions-item>
            <el-descriptions-item label="职位">{{ checkedItem?.titleText || '' }}</el-descriptions-item>
            <el-descriptions-item label="类别">{{ checkedItem?.department || '' }}</el-descriptions-item>
            <el-descriptions-item label="研究领域">{{ checkedItem?.studies || '' }}</el-descriptions-item>
            <el-descriptions-item label="行业研究领域">{{ checkedItem?.industry_sector || '' }}</el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ checkedItem?.email || '' }}</el-descriptions-item>
          </el-descriptions>
        </el-form-item>
        <el-form-item ref="confirmFileUpload" prop="[extra_content][confirmation_file]" :rules="{ required: true, message: '请上传导师确认单', trigger: 'blur' }">
          <upload-component
            accept-type=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            button-text="上传导师确认单"
            :file-list="ruleForm.extra_content.confirmation_file"
            :custom-file-name="customFileName"
            :max-size="15"
            :is-disabled="tutorData?.is_update === 0"
          >
          </upload-component>
        </el-form-item>
        <el-dialog title="选择导师" :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="1200px">
          <el-form :inline="true" :model="searchForm" class="assessment-form">
            <el-form-item label="教授姓名">
              <el-input v-model="searchForm.ThesisTeacherSearch.teacherName" clearable placeholder="请输入论文教授姓名" />
            </el-form-item>
            <el-form-item label="研究领域">
              <el-input v-model="searchForm.ThesisTeacherSearch.studies" clearable placeholder="请输入论文研究领域" />
            </el-form-item>
            <el-form-item label="系别">
              <el-input v-model="searchForm.ThesisTeacherSearch.department" clearable placeholder="请输入系别" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch"> 搜索 </el-button>
              <el-button type="primary" @click="reset"> 重置 </el-button>
            </el-form-item>
          </el-form>
          <ming-table v-if="showTable" v-model="tableData" :fields="tutorTable" max-height="400">
            <template #selection="{ scope }">
              <el-button type="text" @click="handleSelectTutor(scope)">
                {{ checkedItem ? (checkedItem.teacher_id === scope.teacher_id ? '取消选择' : '选择') : '选择' }}
              </el-button>
            </template>
          </ming-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :hide-on-single-page="true"
            :page-size="20"
            :total="pager.totalCount"
            :current-page.sync="currentPage"
            @current-change="pageChange"
          ></el-pagination>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="closeDialog">确定</el-button>
          </span>
        </el-dialog>
      </el-form>
    </div>
    <div v-show="+activeName === 3" class="tab-content" :disabled="savedActiveName < 3">
      <p v-if="(tutorData.data && +tutorData.data.is_submit === 1) || +tutorData.data.teacher_audit_state !== 0">
        选导结果：
        <span v-if="tutorData.data && tutorData.data.teacher_audit_state" :class="'state-' + tutorData?.data?.teacher_audit_state">
          {{ tutorData?.data?.teacher_audit_state_text }}
        </span>
        <span v-else>未审核</span>
      </p>
      <p v-if="tutorData.data && +tutorData.data.teacher_audit_state == 2 && tutorData?.data.reason">原因：{{ tutorData?.data.reason }}</p>
      <page-header title="导师意愿" style="margin: 40px 0 20px 0"></page-header>
      <el-descriptions v-if="checkedItem?.teacher_id > 0" direction="vertical" :column="6" border>
        <el-descriptions-item label="教授姓名">{{ checkedItem?.teacherName || '' }}</el-descriptions-item>
        <el-descriptions-item label="职位">{{ checkedItem?.titleText || '' }}</el-descriptions-item>
        <el-descriptions-item label="类别">{{ checkedItem?.department || '' }}</el-descriptions-item>
        <el-descriptions-item label="研究领域">{{ checkedItem?.studies || '' }}</el-descriptions-item>
        <el-descriptions-item label="行业研究领域">{{ checkedItem?.industry_sector || '' }}</el-descriptions-item>
        <el-descriptions-item label="邮箱">{{ checkedItem?.email || '' }}</el-descriptions-item>
      </el-descriptions>
      <br />
      <el-button
        v-if="tutorData.data && +tutorData.data.is_submit === 1"
        size="mini"
        type="text"
        @click="downloadFile(tutorData?.data?.show?.extra_content?.confirmation_file[0]?.url, tutorData?.data?.show?.extra_content?.confirmation_file[0]?.name)"
      >查看导师确认单</el-button>
    </div>
    <div class="btn-group">
      <el-checkbox v-if="+activeName === 0" v-model="checked">我已阅读通知&nbsp;&nbsp;</el-checkbox>
      <el-button v-else size="small" @click="switchStep(+activeName - 1)">上一步</el-button>
      <el-button
        v-if="+activeName !== 3"
        type="primary"
        size="small"
        :loading="btnloading"
        :disabled="btnDisabled()"
        @click="switchStep(+activeName + 1)"
      >保存进入下一步</el-button>
    </div>
    <p v-show="+activeName === 2">

      提交状态：{{ tutorData.data.is_submit === 1 ? '已提交' : '未提交' }}
      <template v-if="tutorData.data.is_submit && tutorData.data.submit_time">
        <span style="color: #666">（提交时间：{{ timeFormat(tutorData.data.submit_time * 1000) }}）</span>
      </template>

    </p>
    <dialog-work-info v-if="dialogWork" :visible.sync="dialogWork" :data="WorkItemData" :title="DialogWorkTitle" @add="AddWorkInfo" @edit="EditWorkInfo" />
    <change-mobile-dialog v-if="mobileVisible" :visible.sync="mobileVisible" :old-mibile="userForm.mobile" @toUpdate="getUserInfo" />
  </div>
</template>
<script setup>
import { computed, onBeforeMount, ref } from 'vue'
import Router from '@/router'
import Store from '@/store'
import { Message, MessageBox } from 'element-ui'
import api from '@/api'
import UploadComponent from '@/components/UploadComponent'
import PageHeader from '@/components/PageHeader'
import { workInfoColumn } from '@/views/UserCenter/tableColumn'
import ChangeMobileDialog from '@/views/UserCenter/components/ChangeMobileDialog.vue'
import DialogWorkInfo from '@/views/UserCenter/components/DialogWorkInfo.vue'
import { validateField } from '@/utils/validate'
import { tutorTable } from '../tableColumn'
import { timeFormat, downloadFile } from '@/utils'

const routeInfo = ref(Router.currentRoute)
const props = defineProps({
  tutorData: {
    type: Object,
    default: () => {
      return {}
    }
  }
})

const tutorData = computed(() => {
  // return { ...props.tutorData, is_update: 1 }
  return props.tutorData
})

const tabItems = ['须知', '基本信息确认', '选择导师', '选导结果']

// tab切换允许查看
const showTab = ref(0)
// 保存的步骤信息
const savedActiveName = ref(0)
// 当前进行的步骤信息
const activeName = ref(0)
const btnloading = ref(false)
const tabClick = (item, index) => {
  // 禁用
  if (showTab.value < index) {
    return
  }
  activeName.value = index
}
// 是否选择已读选项
const checked = ref(false)
// 保存按钮禁用状态
const btnDisabled = () => {
  let res = false
  if (+activeName.value === 0) {
    if (checked.value) {
      res = false
    } else {
      res = true
    }
  }
  // 选导步骤
  if (+activeName.value === 2) {
    if (tutorData.value.is_update === 0) {
      res = true
    }
  }
  return res
}

/**
 * 步骤切换
 * @param {*} aid 目标步骤
 */
function switchStep(aid) {
  // 下一步
  if (activeName.value <= aid) {
    // 前两步调用保存步骤api
    switch (aid) {
      case 1:
        saveStep(aid)
        break
      case 2:
        updateInfo(aid)
        break
      case 3:
        submitFn(2)
        break
      default:
        break
    }
  } else {
    // 上一步
    activeName.value = aid + ''
  }
}
// step说明：默认为0，用户管理为1。steo的意思是：完成了哪一步
// 保存步骤信息，只有<用户管理>，<基本信息确认>两步，保存的时候需要调用
function saveStep(step) {
  if (savedActiveName.value > 2) {
    return
  }
  api.MBAThesisStepSubmit({ step }).then(res => {
    if (+res.code === 200) {
      updateHandle()
    } else {
      Message.error(res.msg)
    }
  })
}

// 更新数据
const emit = defineEmits(['updateFn'])
function updateHandle() {
  emit('updateFn')
}

const form = ref('')
const userForm = ref({
  address: '',
  email: '', // 邮箱
  mobile: '', // 手机号
  workInfo: [] // 工作履历
})

const rules = ref({
  address: { required: true, message: '请输入现居住地址' },
  mobile: { required: true, validator: validateField('mobile') },
  email: { required: true, validator: validateField('email2') }
})
const fLoading = ref(false)
// 获取用户信息
function getUserInfo() {
  fLoading.value = true
  api
    .userInfo()
    .then(res => {
      if (+res.code === 200) {
        mobileVisible.value = false
        userForm.value.address = res.data.address || ''
        userForm.value.email = res.data.email
        userForm.value.mobile = res.data.mobile
        userForm.value.workInfo = res.data.workInfo
        Store.commit('user/SET_USER_INFO', res.data)
      }
      fLoading.value = false
    })
    .catch(() => {
      fLoading.value = false
    })
}
function updateInfo(step) {
  form.value.validate(valid => {
    if (valid) {
      btnloading.value = true
      api
        .UpdateInfo(userForm.value)
        .then(res => {
          btnloading.value = false
          if (+res.code === 200) {
            Message.success(res.msg)
            saveStep(step)
          } else {
            if (![200, 204, 201, 202].includes(+res.code)) {
              Message.error(res.msg)
            }
          }
        })
        .catch(_ => {
          btnloading.value = false
        })
    }
  })
}

/* 更改用户手机号 */
const mobileVisible = ref(false)
function changeMobileFunc() {
  mobileVisible.value = true
}

/* 工作履历弹窗 */
const column = ref(workInfoColumn)
const dialogWork = ref(false)
const DialogWorkTitle = ref('')
const WorkItemData = ref({})
const WorkInfoTabelData = computed(() => {
  if (!userForm.value.workInfo) return []
  return userForm.value.workInfo
})
const workCurIndex = ref(-1)
function openDialogWork() {
  DialogWorkTitle.value = '添加工作履历'
  dialogWork.value = true
  WorkItemData.value = {}
}

/* 添加工作履历 */
function AddWorkInfo(data) {
  const deepCloneData = JSON.parse(JSON.stringify(data))
  if (userForm.value.workInfo === null) {
    userForm.value.workInfo = []
    userForm.value.workInfo.push(deepCloneData)
  } else {
    userForm.value.workInfo.push(deepCloneData)
  }
}
/* 删除工作履历 */
function delWorkItem(data) {
  if (!data) return
  MessageBox.confirm('是否要删除工作信息？', '提示')
    .then(() => {
      const index = userForm.value.workInfo.indexOf(data)
      userForm.value.workInfo.splice(index, 1)
    })
    .catch(() => {})
}

/* 打开修改弹窗 */
function editWorkItem(data) {
  dialogWork.value = true
  DialogWorkTitle.value = '修改工作履历'
  WorkItemData.value = data
  workCurIndex.value = userForm.value.workInfo.indexOf(data)
}
/* 修改 */
function EditWorkInfo(data) {
  const newTable = userForm.value.workInfo.map((item, index) => {
    if (index === workCurIndex.value) {
      item = data
    }
    return item
  })
  userForm.value.workInfo = newTable
  workCurIndex.value = -1
  WorkItemData.value = {}
}

// 选导表单
const tutorForm = ref('')
const ruleForm = ref({
  teacher_id: '',
  extra_content: {
    confirmation_file: []
  }
})
// 宣导学生数据
const userInfo = computed(() => {
  return Store.state.user.userInfo
})
// 选导文件名字
const customFileName = computed(() => {
  return `导师确认单-${userInfo.value.className}-${userInfo.value.idnumber}-${userInfo.value.name}-${routeInfo.value.meta.title}`
})
const dialogVisible = ref(false)
function openDialog() {
  getTutorData()
  dialogVisible.value = true
}
function closeDialog() {
  dialogVisible.value = false
}

const tableData = ref([])
const searchForm = ref({
  ThesisTeacherSearch: {}
})
const showTable = ref(false)
const pager = ref({})
function getTutorData() {
  const ThesisTeacherSearch = {
    ...searchForm.value.ThesisTeacherSearch
  }
  api.MBAThesisTutorList({ ThesisTeacherSearch, page: currentPage.value }).then(res => {
    if (+res.code === 200) {
      tableData.value = res.data.lists
      pager.value = res.data.pager
    }
    showTable.value = true
  })
}

const checkedItem = ref('')
const handleSelectTutor = row => {
  // 已选导师
  if (checkedItem.value.teacher_id > 0) {
    // 取消选择
    if (checkedItem.value.teacher_id === row.teacher_id) {
      MessageBox.confirm('确定要取消选择该导师吗？', '提示')
        .then(() => {
          checkedItem.value = ''
          ruleForm.value.teacher_id = checkedItem.value.teacher_id
        })
        .catch(() => {})
    } else {
      // 选择其他导师
      MessageBox.confirm(`您已选择${checkedItem.value?.teacherName || '导师'}，请确认是否要更改选到意愿`, '提示')
        .then(() => {
          checkedItem.value = row
          ruleForm.value.teacher_id = checkedItem.value.teacher_id
        })
        .catch(() => {})
    }
  } else {
    checkedItem.value = row
    ruleForm.value.teacher_id = checkedItem.value.teacher_id
  }
}

const currentPage = ref(1)
function pageChange(val) {
  getTutorData()
}

function onSearch() {
  currentPage.value = 1
  getTutorData()
}
function reset() {
  searchForm.value.ThesisTeacherSearch = {}
  currentPage.value = 1
  onSearch()
}

// 提交
// operate：1=>保存，2=>提交
async function submitFn(operate) {
  await tutorForm.value.validate(valid => {
    if (valid) {
      MessageBox.confirm('提交后不支持二次修改，请确认是否继续？', '提示')
        .then(() => {
          btnloading.value = true
          saveFn(operate)
        })
        .catch(() => {})
    }
  })
}

function saveFn(operate) {
  // 处理导师确认单
  const confirmation_file =
    ruleForm.value.extra_content.confirmation_file &&
    ruleForm.value.extra_content.confirmation_file.map(item => {
      return {
        url: item.url,
        name: item.name,
        size: item.size,
        label: routeInfo.value.meta.title,
        ctime: item.ctime || timeFormat(+new Date())
      }
    })

  // 处理提交表单
  const submitForm = {
    teacher_id: checkedItem.value.teacher_id,
    extra_content: {
      confirmation_file: confirmation_file || []
    }
  }

  // 提交
  api
    .MBAThesisTutorSubmit(submitForm)
    .then(res => {
      btnloading.value = false
      if (+res.code === 200) {
        Message.success(res.msg)
        updateHandle()
      } else {
        Message.error(res.msg)
      }
    })
    .catch(err => {
      btnloading.value = false
      console.error(err)
    })
}

onBeforeMount(() => {
  // 设置默认选中的tab
  // 提交过选导或审核过，要可以查看第四步
  activeName.value = tutorData.value.data.step + '' || '0'
  savedActiveName.value = tutorData.value.data.step + '' || '0'
  showTab.value = tutorData.value.data.step + '' || '0'
  if (tutorData.value.data.is_submit === 1 || tutorData.value.data.teacher_audit_state > 0) {
    activeName.value = '3'
    showTab.value = '3'
  }
  if (savedActiveName.value >= 1) {
    checked.value = true
  }
  getUserInfo()

  // 设置选导选中数据
  checkedItem.value = {
    ...tutorData.value.data
  }
  ruleForm.value.teacher_id = tutorData.value.data.teacher_id === 0 ? '' : tutorData.value.data.teacher_id
})
</script>
<style lang="scss" scoped>
.state {
  &-3 {
    color: #e6a23c;
  }

  &-2 {
    color: #f56c6c;
  }

  &-1 {
    color: #67c23a;
  }
}

.admin-remark {
  white-space: pre-line;
}

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  > div {
    width: 40%;
  }
}

.btn-group {
  margin-top: 15px;
}

.tabs {
  display: flex;
  justify-content: flex-start;
  padding-left: 0;
  border-bottom: 1px solid #dfe4ed;

  .tab-item {
    display: block;
    list-style: none;
    cursor: pointer;
    padding: 0 20px;
    line-height: 40px;
    border-top: 1px solid #dfe4ed;
    border-right: 1px solid #dfe4ed;
    border-bottom: 1px solid #dfe4ed;
    margin-bottom: -1px;

    &:first-child {
      border-left: 1px solid #dfe4ed;
    }

    &:hover {
      color: #b22222;
    }

    &.is-active {
      color: #b22222;
      border-bottom-color: #fff;
    }

    &.is-finish {
      &::after {
        // ✅
        content: '✔︎';
        display: inline-block;
        margin-left: 5px;
        color: #67c23a;
      }
    }

    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}

:deep(.el-date-editor) {
  width: 100% !important;
}

:deep(.el-select) {
  width: 100%;
}
</style>
